<div class="container">
  <div class="title">{{ 'auth.projects.title' | translate }}</div>
  <div id="search-bar" class="search-bar">
    <img src="assets/search-purple.svg" alt="Search position" />
    <input
      autofocus
      [value]="searchParam"
      (input)="onTypeSearch($event)"
      [placeholder]="'auth.projects.searchPlaceholder' | translate"
    />
  </div>
  <div class="item-container-mobile-wrapper">
    <div class="item-container">
      <div
        class="zero-screen"
        *ngIf="
          isLoading &&
          (!displayedProjects?.length || displayedProjects.length === 0)
        "
      >
        <div class="instructions">
          {{ 'auth.projects.loading' | translate }}
        </div>
      </div>

      <div
        class="zero-screen"
        *ngIf="!isLoading && displayedProjects.length === 0"
      >
        <div class="instructions">
          {{ 'auth.projects.noProjects' | translate }}
        </div>
      </div>

      <ng-container *ngIf="existingProjects.length !== 0">
        <div
          class="item"
          *ngFor="let project of existingProjects; let i = index"
        >
          <div class="names">
            <div class="client">
              <div class="label">
                {{ 'auth.projects.client' | translate }}&nbsp;
              </div>
              <div class="value">
                {{ project.client?.name }}
              </div>
              <div class="status-container-mobile">
                <ops-project-status
                  [isPreview]="true"
                  [selectedStatus]="project.status"
                ></ops-project-status>
              </div>
            </div>
            <div class="project">
              <div class="label">
                {{ 'auth.projects.projectName' | translate }}&nbsp;
              </div>
              <div class="value">
                {{ project.name }}
              </div>
            </div>
            <div class="code">
              <div class="label">
                {{ 'auth.projects.projectCode' | translate }}&nbsp;
              </div>
              <div class="value">
                {{ project.code }}
              </div>
            </div>
          </div>
          
          <div class="scope-action-container">
            <div class="scope-container">
              <div class="scope" *ngFor="let scope of project.scope">
                <div class="checkmark">
                  <img src="assets/checkmark.svg" />
                </div>
                <div class="type">
                  {{ scope | translate }}
                </div>
              </div>
            </div>
            <div class="action-container">
              <div
                class="action estimate clickable"
                tabindex="0"
                role="button"
                enterPress="onClickEstimate(project)"
                (keydown.enter)="onClickEstimate(project)"
                (click)="onClickEstimate(project)"
              >
                {{ 'auth.projects.projectEstimate' | translate }}
                <img src="assets/arrow-right-white.svg" />
              </div>
              <div
                class="action cost"
                tabindex="0"
                role="button"
                enterPress="onClickCost(project)"
                (keydown.enter)="onClickCost(project)"
                (click)="onClickCost(project)"
                *ngIf="!guestView"
              >
                {{ 'auth.projects.productionCosts' | translate }}
                <img src="assets/arrow-right-white.svg" />
              </div>
            </div>
            <button
              class="action-mobile-button"
              (click)="onAddProjectCost(project)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="39"
                height="39"
                viewBox="0 0 39 39"
                fill="none"
              >
                <path
                  d="M19.5 13V26M26 19.5H13M19.5 35.75C28.4746 35.75 35.75 28.4746 35.75 19.5C35.75 10.5254 28.4746 3.25 19.5 3.25C10.5254 3.25 3.25 10.5254 3.25 19.5C3.25 28.4746 10.5254 35.75 19.5 35.75Z"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
          <div class="status-container">
            <ops-project-status
              [isPreview]="true"
              [selectedStatus]="project.status"
            ></ops-project-status>
          </div>
          <div
            *ngIf="project.status !== '2' && project.status !== '3' && project.status !== '4'"
            class="kebab-menu"
            [opsActionMenu]="'kebab' + project._id"
            [optionsFactory]="getDropdownOptions.bind(this, project)"
            [position]="'auto'"
            [offset]="{ x: -10, y: 5 }"
          >
            <img src="assets/kebab-menu-white.svg" />
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="action-menus-container">
    <ops-action-menu
      *ngFor="let project of existingProjects"
      [menuId]="'kebab' + project._id"
      (itemSelected)="onSelectProjectAction(project, $event)"
    ></ops-action-menu>
  </div>
  <div class="button-container">
    <div class="btn-new btn" (click)="onClickNewProject()">
      {{ 'auth.projects.createNewProject' | translate }}
    </div>
  </div>
</div>
<ops-add-cost 
  id="add-cost-modal-dashboard"
  [projectId]="selectedProjectId"
  (costAdded)="onCostAdded($event)"
></ops-add-cost>
<ops-project-info-modal
  id="project-info-modal"
  (projectEmitter)="editProject($event)"
></ops-project-info-modal>
<ops-duplicate-project-modal
  id="duplicate-project-modal"
  (projectDuplicated)="onProjectDuplicated($event)"
></ops-duplicate-project-modal>
